import script from "./Px2.vue?vue&type=script&setup=true&lang=js"
export * from "./Px2.vue?vue&type=script&setup=true&lang=js"

import "./Px2.vue?vue&type=style&index=0&id=ead4a9c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead4a9c2"]])

export default __exports__